module.exports = __webpack_public_path__ + "img/circle-shape.0c02127a.png";